import { color } from '@mui/system';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { GeneralCard } from '../../../../components/Cards/GeneralCard';
import { ProgressChart } from '../../../../components/CHARTS/Progress/ProgressChart';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import BasicDatePicker from '../../../../components/Datepicker/Datepicker';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Input from '../../../../components/Inputs/Input';
import Item from '../../../../components/Lists/Item';
import { SearchBar } from '../../../../components/SearchBar/SearchBar';
import { SortingHeader } from '../../../../components/Sorting/SortingHeader';
import { Tag } from '../../../../components/Tags/Tag';
import TimeControls, { defaultColorGradient } from '../../../../components/TimeControls/TimeControls';
import { SortingProvider } from '../../../../contexts/SortingContext';
import './ScheduleDialog.scss';
import { useState } from 'react';
import { RangeSelector } from '../../../../components/RangeSelector/RangeSelector';
import { setSites } from '../../../../redux/features/configuration/locations/locationsSitesSlice';
import { SpecificOverrides } from '../PartsConfiguration/SpecificOverrides';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { SpecificSchedule } from './SpecificSchedule';



const mockItem = { partNumber: "986557432", serialNumber: "24733874382", description: "Lorem ipsum 123", useFlightDays: "--", repeatNumber: "9999" }

const mockAircraft = { typeSeries: "A320-232", tailNumber: "N616NK", useFlightDays: true, repeatNumber: 2378 }
const LocalCheckbox = (item, key) => {
    return <Checkbox checked={true} />
}

const saveButtons = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];


export const ScheduleDialog = ({ onClose }) => {

    const [tab, setTab] = useState("PN");

    return (<div className='schedule-dialog-component'>
        <div className='dialog-header'>
            <div className='title'>
                <b>Aircraft and PNs</b>
                {/* <button className="filled iconTextButton">
                    <span>+</span> <span>Add PN</span>
                </button> */}
            </div>
            <button className='outlined icon small-size' onClick={onClose}>
                <i className='icon-cross'></i>
            </button>

        </div>
        <div className='tabswitch'>
            <button className={`transparent ${tab === "PN" ? "active" : ""}`} onClick={() => setTab("PN")}> PN </button>
            <button className={`transparent ${tab === "Aircraft" ? "active" : ""}`} onClick={() => setTab("Aircraft")}> Aircraft </button>
        </div>

        <div className='subtitle'>
            <b>Schedule {tab}</b>
            <button className="filled iconTextButton small-size">
                <span>+</span> <span>Add {tab}</span>
            </button>

        </div>


        {tab === "PN" ? <>
            <div className='dialogContent'>
                <SortingContainer tab={tab}>
                    <SortingHeader />
                    <PartItem tab={tab} />

                </SortingContainer>


            </div>
        </> :
            <div className='dialogContent'>
                <SortingContainer tab={tab}>
                    <SortingHeader />
                    <PartItem tab={tab} />

                </SortingContainer>


            </div>
        }



    </div>)

}

const PartItem = ({ tab }) => {
    const [overrideGeneral, setOverrideGeneral] = useState(true);
    const [isRange, setIsRange] = useState(true);
    const pnDropdown = useDropdownConfig(tab === "PN" ? 29 : 114);
    const [accountParameter, _] = useState([{ "columnName": "accountId", value: localStorage.getItem('u_account_id') }]);
    const [selectionItems, setSelectionItems] = useState([
        [
            { "id": 0, "serialNumber": "387873823" },
            { "id": 1, "serialNumber": "928374652" },
            { "id": 2, "serialNumber": "174839201" },
            { "id": 3, "serialNumber": "564738291" },
            { "id": 4, "serialNumber": "837261945" },
            { "id": 5, "serialNumber": "293847561" },
            { "id": 6, "serialNumber": "748392016" },
            { "id": 7, "serialNumber": "182736495" },
            { "id": 8, "serialNumber": "657483920" },
            { "id": 9, "serialNumber": "394857261" },
            { "id": 10, "serialNumber": "918273645" },
            { "id": 11, "serialNumber": "384756192" },
            { "id": 12, "serialNumber": "274839105" },
            { "id": 13, "serialNumber": "847362910" },
            { "id": 14, "serialNumber": "102938475" }
        ]
    ])
    return (
        <Expandable2 summary={<Item lightFont hideLabels item={mockItem} renderProperty={{ useFlightDays: LocalCheckbox }}>
            <i className='icon-delete-new'></i>
        </Item>}>
            <div className='exp-content'>
                <div className='general-card-component pn-selector'>
                    <b>{tab === "PN" ? "PN" : "AC Type/Series"}</b>
                    <Dropdowns hideLabel data={pnDropdown.config} parameters={accountParameter} selectionLabel="name" optionLabel="name" />
                    <MultioptionButton buttons={saveButtons} />
                </div>
                <div className='ranges'>
                    <RangeSelector tab={tab} itemLabel='serialNumber' isRange={isRange} selectionTypeChange={(v) => setIsRange(v)} editing={true} selectorSuffix={
                        <></>
                    } />
                    <div>
                        {/* <CheckboxField checked={overrideGeneral} onChange={(newV) => setOverrideGeneral(newV)}>Override General Schedule</CheckboxField> */}
                        {overrideGeneral && <>
                            {/* <div className='repeat-container' style={{}}>
                                <i style={{}}>Repeat Number</i>
                                <Input />
                            </div> */}
                            <div className='general-card-component threshold'>
                                <div className='checkboxes'>
                                    <CheckboxField checked={true}>Override General Schedule</CheckboxField>
                                    <Input fixedLabel centerLabel label="Repeat Number" />

                                </div>
                                <div className='checkboxes'>
                                    <CheckboxField checked={false}>Latest</CheckboxField>
                                    <CheckboxField checked={true}>Use Flight Days</CheckboxField>

                                </div>
                                <b> </b>
                                {/* <i>Hours</i> */}
                                <b>Threshold</b>
                                <Input centerLabel fixedLabel label="Hours" />
                                <Input centerLabel fixedLabel label="Cycles" />
                                <Input centerLabel fixedLabel label="Days" />
                                <Input centerLabel fixedLabel label="Total Hours" />
                                <Input centerLabel fixedLabel label="Total Cycles" />
                                <Input centerLabel fixedLabel label="Total Days" />
                                <div className='schedule'>
                                    <b>Schedule Date</b>
                                    <BasicDatePicker />
                                </div>
                                <b>Interval</b>
                                <Input centerLabel fixedLabel label="Hours" />
                                <Input centerLabel fixedLabel label="Cycles" />
                                <Input centerLabel fixedLabel label="Days" />
                                <div className='schedule'>
                                    <b>Schedule Date</b>
                                    <BasicDatePicker />
                                </div>
                                {/* <i>Cycles</i>
                                <Input label="" />
                                <i>Days</i>
                                <Input label="" />
                                <i>Total Hours</i>
                                <Input label="" />
                                <i>Total Cycles</i>
                                <Input label="" />
                                <i>Total Days</i>
                                <Input label="" />
                                <i>Schedule Date</i>
                                <Input label="" /> */}

                            </div> </>}
                    </div>
                </div>
                <SpecificSchedule />

                <SpecificOverrides timeControl={{ id: 0 }} overrides={[]} />
            </div>

        </Expandable2>
    )

}

const SortingContainer = ({ children, tab }) => {


    return (
        <SortingProvider properties={
            tab === "PN" ?
                { partNumber: "PN", serialNumber: "SN", description: "Description", useFlightDays: "Use Flight Days", repeatNumber: "Repeat Number" }
                : { typeSeries: "Type and Series", tailNumber: "Tail Number", useFlightDays: "Use Flight Days", repeatNumber: "Repeat Number" }

        }>
            {/* <DropdownsProvider> */}
            {children}
            {/* </DropdownsProvider> */}
        </SortingProvider>
    )

}